import { useReducer, useEffect } from "react";
import forms from "../data/forms";

const ActionTypes = {
  LOADING: "loading",
  SUCCESS: "success",
  FAILURE: "failure",
};

const initState = {
  loading: false,
  loaded: false,
  error: undefined,
  showInterestedVehicle: undefined,
  showPreferredMethodOfContact: undefined,
  showMessage: undefined,
  terms: undefined,
  accountId: undefined,
};

function reducer(state, action) {
  switch (action.type) {
    case ActionTypes.LOADING:
      return { ...state, loading: true, loaded: false, error: undefined };
    case ActionTypes.SUCCESS:
      const { data } = action;
      const fields = new Map(data.map((field) => [field.name, field]));

      const showInterestedVehicle = fields.has("vehicleOfInterestYear");
      const { values = [] } = fields.get("termsAndConditions");
      const showPreferredMethodOfContact = fields.has(
        "preferredMethodOfContact"
      );
      const showMessage = fields.has("message");
      return {
        ...state,
        loading: false,
        loaded: true,
        showInterestedVehicle,
        showPreferredMethodOfContact,
        showMessage,
        terms: values && values.join(" "),
      };
    case ActionTypes.FAILURE:
      return { ...state, loading: false, loaded: false, error: action.error };
    default:
      throw new Error(`Unknown action type ${action.type}`);
  }
}

export default function useForms(initAccountId) {
  const [state, dispatch] = useReducer(reducer, {
    ...initState,
    accountId: initAccountId,
  });

  const { accountId } = state;

  useEffect(
    function loadForms() {
      async function getForms() {
        dispatch({ type: ActionTypes.LOADING });
        try {
          const data = await forms({ accountId });
          dispatch({ type: ActionTypes.SUCCESS, data });
        } catch (err) {
          dispatch({ type: ActionTypes.FAILURE, error: err });
        }
      }

      if (accountId) {
        getForms();
      }
    },
    [accountId, dispatch]
  );

  return state;
}
